import { AppDispatch } from 'app/store';
import { getAPI } from 'services/api/apiAsync';
import { API_ENDPOINTS } from 'utils/constants';
import * as offer from './offerSlice';
import type { IOffer } from './types';

export function getOfferDetailsByPrefix(code: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.getMarketingOfferDetails}?prefixCode=${code}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(offer.setOffer(response));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function getOfferDetails() {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.getMarketingOffer}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(
        offer.setOffer({
          ...response.offer,
          planCode: response.plan?.code,
          planName: response.plan?.name,
          companyCode: response.group?.code,
          isUserInTrial: response.isUserInTrial,
        }),
      );
      dispatch(offer.setGroup(response.group));
      if (response?.scheduledOffer) {
        dispatch(offer.setScheduledOffer(response.scheduledOffer));
      }
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

/**
 * Function to fetch the marketing offer details based on offerCode and planCode
 */
export function fetchOfferDetailsByCode(offerCode: string, planCode: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.getMarketingOfferDetails}/${offerCode}?planCode=${planCode}`,
      };
      const response: IOffer = await dispatch(getAPI(config)).unwrap();
      dispatch(offer.setOffer(response));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
